export default "__VITE_ASSET__Bncd6acB__"